import { render } from "./FooterComponent.vue?vue&type=template&id=3c34b970&ts=true"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__